module.exports = __webpack_public_path__ + "img/real-estate-team.c97e8bcb.jpg";